import { motion } from 'framer-motion';

interface Step {
  currentStep: number;
  totalSteps: number;
}
export function StepsIndicator({ currentStep, totalSteps }: Step) {
  // A single dot conveys no progress — render nothing for single-step wizards (#5503).
  if (totalSteps <= 1) return null;
  return (
    <div className='flex justify-center items-center space-x-3 mb-8'>
      {Array.from({ length: totalSteps }, (_, index) => (
        <motion.div
          key={`steps-indicator-${index}`}
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ 
            duration: 0.3, 
            delay: index * 0.05,
            type: "spring",
            stiffness: 400,
            damping: 10
          }}
          className={`w-2 h-2 rounded-full transition-colors duration-200 ${
            index < currentStep 
              ? 'bg-[#290BD9]' 
              : 'bg-white border border-gray-300'
          }`}
        />
      ))}
    </div>
  );
}
